import { useQuery } from '@tanstack/react-query';
import { getTodoTasksAction } from '../actions/getTodoTasks.action';

export const useGetTodoTasks = () => {
  return useQuery({
    queryKey: ['todo-tasks'],
    queryFn: () => getTodoTasksAction(),
    staleTime: 1000 * 60 * 5, // 5 minutes
    gcTime: 1000 * 60 * 10, // 10 minutes
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
  });
};

